import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants';

/*

Props:

buttonColorAlt
color
altColor

*/

const StyledButton = styled.button`
    box-sizing: border-box;/* not working? */
    font-size: 16px;
    font-weight: 500;
    text-transform: capitalize;
    text-decoration: none;
    font-family: ${constants.text.displayFont.fontFamily};
    color: ${props => (props.color || props.altColor) ? ((props.altColor) ? constants.color.grey34 : props.color) : constants.color.dark};
    background-color: ${props => !props.disabled ? (props.buttonColorAlt ? constants.color.primaryDark : constants.color.secondary) : constants.color.grey5 };
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer' };
    padding: 10px 60px;
    border-radius: 8px;
    border-color: ${props => !props.disabled ? (props.buttonColorAlt ? constants.color.primaryDark : constants.color.secondary) : 'rgba(0,0,0,0.2)'};
    border-style: solid;
    box-shadow: 1px 0px 20px 0px rgba(0,0,0,0.1);
    :hover { 
        /* box-shadow: 1px 0px 20px 0px rgba(0,0,0,0.3);  */
        background-color: ${props => !props.disabled ? (props.buttonColorAlt ? constants.color.primary : constants.color.secondaryLight) : constants.color.grey5 };
        cursor: ${props => props.disabled ? 'not-allowed' : 'pointer' };
        border-color: ${props => props.disabled && 'rgba(0,0,0,0.2)'};
    }
    :active { 
        /* box-shadow: 1px 0px 20px 0px rgba(0,0,0,0.3);  */
        background-color: rgba(0,0,0,0.1);
    }
    @media (max-width: ${props => (props.breakPoint1) ? props.breakPoint1 : '0'}px){

    }
`;


const Button = ({ style, href, onClick, children, noBlank=false, ...rest }) => (
    <StyledButton style = {style} onClick = {onClick} {...rest} >
        { children }
    </StyledButton>
) 

export default Button;



// WEBPACK FOOTER //
// ./src/js/components/Primatives/Button.jsx